<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <Loader v-if="!isLoaded"/>
          <div v-else>

            <BackButton
                :label="$t('general.button.back')"
                :to="{ name: 'coachBillingPendingBills' }"
                marginBottom="5"/>

            <div class="d-flex justify-content-between">
              <h6 class="element-header">
                {{ $t('general.messages') }}
              </h6>
            </div>

            <div class="element-box">
              <div class="full-chat-w">
                <div class="full-chat-i">
                  <div class="full-chat-middle">

                    <div class="chat-head">
                      <div class="user-info">
                        <span>An:</span>
                        <span style="color: #43ad4e">
                        <template v-if="coachBill?.coach?.externalCoordinator">
                          Externer Koordinator -
                          {{
                            coachBill?.coach?.externalCoordinator?.firstName
                          }}  {{ coachBill?.coach?.externalCoordinator?.lastName }}
                        </template>
                        <template v-else>
                          {{ coachBill?.coach?.firstName }}  {{ coachBill?.coach?.lastName }}
                        </template>
                      </span>
                        <br>
                        <div style="font-size: 14px;">
                          <span>Rechnungs-Nr.: &nbsp;&nbsp; GS{{ coachBill?.billNumber }}</span><br>
                          <span>Rechnungsdatum: &nbsp;&nbsp; {{ coachBill?.createdAt }}</span><br>
                          <span>Sitzungen: &nbsp;&nbsp; {{ coachBill?.totalUnits }}</span><br>
                          <span>Rechnungsbetrag: &nbsp;&nbsp; {{ coachBill?.sum }} €</span>
                        </div>
                      </div>
                    </div>

                    <div class="chat-content-w">
                      <div class="chat-content">
                        <div v-if="coachBill?.messages?.length === 0" class="text-center mt-5">
                          <p style="font-size: 18px; font-weight: lighter">
                            Es liegen keine Nachrichten vor. Schreiben Sie die erste Nachricht, um das Gespräch zu
                            beginnen.
                          </p>
                        </div>

                        <div v-for="message in coachBill.messages" :key="message.id">
                          <div v-if="message?.accountant != null" class="chat-message self">
                            <div class="chat-message-content-w">
                              <div class="chat-message-content"
                                   style="background-color: rgba(67, 173, 78, 0.5)!important;">
                                {{ message.text }}
                              </div>
                            </div>
                            <div class="chat-message-date">
                              {{ message.createdAt }}
                            </div>
                            <div class="chat-message-avatar">
                              <img alt="" src="../../../../../assets/img/user.jpg">
                            </div>
                          </div>

                          <div v-else class="chat-message">
                            <div class="chat-message-content-w">
                              <div class="chat-message-content"
                                   style="background-color: #f0f9ff!important;">
                                {{ message.text }}
                              </div>
                            </div>
                            <div class="chat-message-avatar">
                              <img alt="" src="../../../../../assets/img/user.jpg">
                            </div>
                            <div class="chat-message-date">
                              {{ message.createdAt }}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                    <form @submit.prevent="sendMessage" novalidate>
                      <div style="margin-bottom: -42px; margin-left: -15px;">
                        <i style="font-size: 26px; color: #43ad4e;" class="os-icon os-icon-mail-07"></i>
                      </div>

                      <div class="chat-controls">
                        <label style="width: 100%; border-bottom: 1px solid #43ad4e">
                          <input name="message"
                                 v-model="formData.text"
                                 :placeholder="$t('general.message_placeholder')"
                                 autocomplete="off"
                                 type="text"
                                 style="
                                         border: none;
                                         display: block;
                                         width: 100%;
                                         outline: none;
                                         padding: 15px 20px 10px 0;
                                         font-size: 14px;">
                        </label>
                      </div>
                      <div class="text-center">
                        <button class="btn btn-primary" type="submit">{{ $t('general.button.save') }}</button>
                      </div>
                    </form>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Sidebar></Sidebar>
    </div>
  </div>
</template>

<script setup>
import coachBillingService from '@/api/CoachBilling';
import CreateButton from '@/components/CreateButton.vue';
import Sidebar from '@/components/FormSidebar.vue';
import Loader from '@/components/Loader.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import BackButton from "@/components/button/BackButton.vue";

const { t }        = useI18n();
const route        = useRoute();
const billId       = route.params.id;
const coachBill    = ref('');
const isLoaded     = ref(false);
const isSubmitting = ref(false);

async function getBillDetails() {
  try {
    const { data }  = await coachBillingService.getBillDetails(billId);
    coachBill.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

const formData = ref({
  coachBillId: +billId,
  text: '',
});

async function sendMessage() {
  try {
    if (isSubmitting.value) return;
    isSubmitting.value = true;

    await coachBillingService.sendChatMessageAsAccountant(formData.value);
    await getBillDetails();

    formData.value.text = '';
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function setMessagesAsSeen() {
  try {
    await coachBillingService.setMessageAsSeen(coachBill.value.id);
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await Promise.all([
    await getBillDetails(),
    await setMessagesAsSeen(),
  ]);

  isLoaded.value = true;
});


</script>

<style scoped>

</style>